import { API_TYPE } from '@umu/umu-fetch';

const API = {
    SET_NAV_PERMISSION: {
        url: `/uapi/v1/enterprise/set-se-nav-permission`,
        type: API_TYPE.GET,
    },
    SET_ACCOUNT_PERMISSION: {
        url: `/api/manage/updateaccessuser`,
        type: API_TYPE.POST,
    },
    GET_NAV_BASIC_INFO: {
        url: '/uapi/v1/enterprise/get-customize-nav',
        type: API_TYPE.GET,
    },
    GET_NAV_PERMISSION_ACCOUNT_LIST: {
        url: '/api/manage/getcourseaccesslist',
        type: API_TYPE.GET,
    },
    GET_COURSE_INFO: {
        url: '/ajax/group/getgroupinfo',
        type: API_TYPE.GET,
    },
    GET_PROGRAM_INFO: {
        url: '/api/program/getinfo',
        type: API_TYPE.GET,
    },
    GET_COURSE_TIMING_SWITCH_INFO: {
        url: '/uapi/v1/course/get-timing-switch',
        type: API_TYPE.GET,
    },
    GET_MICRO_PAGE_INFO: {
        url: '/uapi/v1/micro-page/page/get-info',
        type: API_TYPE.GET,
    },
    GET_SESSION_INFO: {
        url: '/ajax/session/getsessionInfo',
        type: API_TYPE.GET,
    },
    GET_SESSION_TIMING_INFO: {
        url: '/uapi/v1/session/get-timing-switch',
        type: API_TYPE.GET,
    },
    GET_CHECK_PERMISSION: {
        url: '/uapi/v1/enterprise/auth-cover',
        type: API_TYPE.GET,
    },
    GET_NAV_USE_PLATE_MEMBER_LIST: {
        url: '/uapi/v1/enterprise/get-se-accounts',
        type: API_TYPE.GET,
    },
    SET_CANCEL_PERMISSION_ALL: {
        url: '/uapi/v1/access-permission/cancel-all-assigned-permission',
        type: API_TYPE.POST,
    },
};
export { API };
